import React from 'react';
import PropTypes from 'prop-types';
import { SecondaryNav, BreadCrumbs } from 'components/organisms';
import { PSPSection } from 'components/molecules/PSPSection';
import { Section } from 'components/core/Page';
import { StickySearchBar } from 'components/landing/StickySearchBar';
import { pageTypes } from 'config/pageTypes';
import { Crumb } from 'components/molecules';
import { toKebabCase } from '../../../lib/helpers';
import './PSPLayout.scss';

function PSPLayout({
	content,
	pageSchema,
	pageType,
	handleSearch,
	contentType,
	keyword,
	pathname,
	siteSchema,
	mainPageGuideSchema,
	individualPageGuideSchema,
	isSizeGuideHomePage,
}) {
	const { sections } = content;
	console.log('sections', sections[sections.length - 1].background);
	const fallbackTriggerId = toKebabCase(sections[0].title);
	const triggerId =
		pageType === 'CubeSmart' || pageType === 'Portable'
			? fallbackTriggerId
			: `psp-${
					pageType === 'size-guide' ? 'search-bar' : 'hero'
				}-sticky-search`;
	return (
		<div className={`${pageType} psp-layout`}>
			<StickySearchBar
				handleSearch={handleSearch}
				triggerId={triggerId}
			/>
			{contentType === 'PSP' && (
				<BreadCrumbs
					pageType="psp"
					crumbs={[
						<Crumb
							key="home"
							href="/"
							label="Home"
						/>,
						<Crumb
							key="pageType"
							isLast
							label={`${pageType} Storage`}
						/>,
					]}
				/>
			)}
			<Section className="psp-body">
				{contentType === pageTypes.SGP && (
					<SecondaryNav active={keyword} />
				)}
				{sections.map((section, index) => (
					<PSPSection
						{...section}
						id={pageType}
						// eslint-disable-next-line react/no-array-index-key
						key={`${section.title}-${index}`}
					/>
				))}
			</Section>

			{contentType == pageTypes.SGP && (
				<BreadCrumbs
					background={
						!sections[sections.length - 1].background ? 'gray' : ''
					}
					pageType="sgp"
					crumbs={[
						<Crumb
							href="/"
							key="home"
							label="Home"
							name="Homepage"
							isLast={false}
						/>,
						<Crumb
							href="/storage-unit-size-guide.html"
							key="size-guide"
							label="Storage Unit Size Guide"
							name="Storage Unit Size Guide"
							isLast={false}
						/>,
						<Crumb
							href={pathname}
							key="pageType"
							isLast
							label={`${pageType} Storage`}
							name={`${pageType}  Storage Unit Size Guide`}
						/>,
					]}
				/>
			)}
			<script
				key="schema"
				type="application/ld+json"
				dangerouslySetInnerHTML={{ __html: pageSchema }}
			/>

			{contentType === pageTypes.SGP && (
				<>
					<script
						key="schema"
						type="application/ld+json"
						dangerouslySetInnerHTML={{ __html: siteSchema }}
					/>
					{isSizeGuideHomePage ? (
						<script
							key="schema"
							type="application/ld+json"
							dangerouslySetInnerHTML={{
								__html: mainPageGuideSchema,
							}}
						/>
					) : (
						<script
							key="schema"
							type="application/ld+json"
							dangerouslySetInnerHTML={{
								__html: individualPageGuideSchema,
							}}
						/>
					)}
				</>
			)}
		</div>
	);
}

PSPLayout.propTypes = {
	pageSchema: PropTypes.string,
	content: PropTypes.object,
	handleSearch: PropTypes.func,
	storageCalculatorUrl: PropTypes.string,
	disableJumpSection: PropTypes.bool,
	pageType: PropTypes.string,
	contentType: PropTypes.string,
	keyword: PropTypes.string,
	pathname: PropTypes.string,
	siteSchema: PropTypes.string,
	siteGuideSchema: PropTypes.string,
	pageGuideSchema: PropTypes.string,
};

PSPLayout.defaultProps = {
	storageCalculatorUrl: '',
	siteSchema: '',
	siteGuideSchema: '',
	pageGuideSchema: '',
	contentType: pageTypes.PSP,
};

export default PSPLayout;
